$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 30; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active");
        $("body").toggleClass("freeze");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderImage
    // *
    // *
    var $sliderImage = $(".js-sliderimage");

    if ($sliderImage.length) {
        $sliderImage.each(function () {
            $(this).slick({
                fade: true,
                infinite: true,
                arrows: false,
                autoplay: false,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).siblings(".js-sliderimage-dots"),
            });
            
        });
    }

    $(".slick-dots button").each(function() {
        var number = parseInt($(this).html()); // Parse to integer!
    
        if (number < 10) {
            number = "0" + number;
        }
    
        $(this).html(number); // Update the button's HTML
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderImageAlt
    // *
    // *
    var $sliderImageAlt = $(".js-sliderimagealt");

    if ($sliderImageAlt.length) {
        $sliderImageAlt.each(function () {
            $(this).slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: false,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                prevArrow: $(this).siblings(".js-sliderimagealt-prev"),
                nextArrow: $(this).siblings(".js-sliderimagealt-next"),
            });
            
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    $(".js-accordion-item").click(function () {
        $(this).toggleClass("active");
        $(this).siblings(".js-accordion-item").removeClass("active open");
        setTimeout(() => {
            $(this).get(0).scrollIntoView({ behavior: 'smooth' })
        }, 400);
    });

    // open accordion with anchor link
    let hash = window.location.hash.split('#')[1];
    if ($("#" + hash).hasClass("js-accordion-item") && !$("#" + hash).hasClass("open")) {
        $("#" + hash).find(".js-accordion").click();
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem('dialogState', true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});
